import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { apiError } from '../../../helpers/ErrorHelper';
import { useAuth } from '../../../context/AuthContext';
import { removeRole, saveRolesToStorage } from '../../../models/UserModel';
import { useNotificationCount } from '../../../context/NotificationCountContext';


const DeleteUserRoleModal = ({showModal, setShowModal, roleData, modalKey, fetchRoles}) => {

  const { notificationCount, setNotificationCount } = useNotificationCount();

  const navigate = useNavigate();

    const { state } = useAuth(); 

    let user_data = state.user_data;
    
    const loader = document.getElementById('loading');

    const [loading, setLoading] = useState(false);
    
    const [_urole_id, setRoleID] = useState('');

    const closeModal = () =>{
        setRoleID('');
        setShowModal(false);
    }

    useEffect(() => {
        // This effect will be called whenever noteData changes
        if (roleData) {
            setRoleID(roleData._urole_id);
        }
    }, [roleData, modalKey]);


    const deleteRole = async() => {
        // Start the loading state
        loader.style.display = 'block';
    
        try {
          const response = await removeRole(user_data.user_token, _urole_id);
    
          if (response.status) {
            toast.success(response.message);
    
            closeModal();
    
            saveRolesToStorage(response.data.user_roles);
    
            fetchRoles();

            setNotificationCount(localStorage.getItem('unread_notification_count'));
          }
          else{
            toast.error(response.message);
          }  
    
        } catch (error) {
          apiError(error);

          if (error.response.data.invalid_token==1) {
            navigate('/re-login');
          }
        }
    
        // Stop the loading state
        loader.style.display = 'none';
    }

    return (
        <Modal show={showModal} onHide={closeModal}>
            <Modal.Header closeButton>
                <Modal.Title>Delete Role</Modal.Title>
            </Modal.Header>
    
            <Modal.Body>
                <p>Do you want to delete this role ? This process can't be undone</p>
            </Modal.Body>
    
            <Modal.Footer>
                <button type="button" className="btn btn-light" onClick={closeModal}>Cancel</button>
                <button type="button" className="btn btn-danger" onClick={deleteRole}>Delete</button>
            </Modal.Footer>
        </Modal>
    );  

}; 


export default DeleteUserRoleModal;